<!-- dashboard -->
<template lang="html">
  <div id="dashboard">
    Dashboard content will go here
  </div>
</template>
<script>
export default {
  name: 'dashboard'
}
</script>



// WEBPACK FOOTER //
// dashboard.vue?6572713e